import { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      // Small delay before showing banner for better UX
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    if (typeof window.fbq === "function") window.fbq("consent", "grant");
    closeBanner();
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    if (typeof window.fbq === "function") window.fbq("consent", "revoke");
    closeBanner();
  };

  const closeBanner = () => {
    setIsClosing(true);
    setTimeout(() => setIsVisible(false), 300);
  };

  if (!isVisible) return null;

  return (
    <div 
      className={`fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 transition-all duration-300 ${
        isClosing ? "translate-y-full opacity-0" : "translate-y-0 opacity-100"
      }`}
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-4xl mx-auto bg-[#0d1320] border border-white/10 rounded-2xl p-5 md:p-6 shadow-2xl shadow-black/50">
        <div className="flex flex-col md:flex-row md:items-center gap-4">
          {/* Icon and Text */}
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 bg-jp-lime/20 rounded-full flex items-center justify-center flex-shrink-0">
                <Cookie className="w-5 h-5 text-jp-lime" />
              </div>
              <h3 className="font-body font-semibold text-white text-base">
                Utilizamos cookies
              </h3>
            </div>
            <p className="font-body text-white/50 text-sm leading-relaxed md:ml-13">
              Este site utiliza cookies para melhorar a sua experiência de navegação. 
              Ao continuar a navegar, concorda com a nossa{" "}
              <a 
                href="/privacidade" 
                className="text-jp-lime underline hover:no-underline"
                onClick={(e) => e.stopPropagation()}
              >
                Política de Privacidade
              </a>.
            </p>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-3 md:flex-shrink-0">
            <button
              onClick={handleDecline}
              className="px-5 py-2.5 rounded-full font-body font-medium text-sm text-white/60 hover:text-white hover:bg-white/10 transition-all"
              data-testid="cookie-decline-btn"
            >
              Recusar
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2.5 rounded-full font-body font-semibold text-sm bg-jp-lime text-black hover:bg-jp-lime-dark transition-all"
              data-testid="cookie-accept-btn"
            >
              Aceitar
            </button>
          </div>

          {/* Close button for mobile */}
          <button
            onClick={handleDecline}
            className="absolute top-3 right-3 md:hidden w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
            data-testid="cookie-close-btn"
            aria-label="Fechar aviso de cookies"
          >
            <X size={16} className="text-white/60" />
          </button>
        </div>
      </div>
    </div>
  );
}
